import { FC, ReactNode } from 'react';
import { ScaleLoader } from 'react-spinners';
import { twMerge } from 'tailwind-merge';

interface IDgSpinnerFull {
	isLoading: boolean;
	children: ReactNode;
	hasHeight?: boolean;
	className?: string;
	width?: number;
	height?: number;
}

const DgSpinnerFull: FC<IDgSpinnerFull> = ({ isLoading = false, children, hasHeight = true, className, width = 2, height = 24 }) => {
	return isLoading ? (
		<div className='relative'>
			<div className={twMerge(`flex items-center z-50 absolute bg-[var(--dg-loading-bg)] justify-center w-full ${hasHeight ? 'h-full' : 'h-auto'} ${className}`)}>
				<ScaleLoader width={width} height={height} color='var(--dg-orange-color)' />
			</div>
			{children}
		</div>
	) : (
		<>{children}</>
	);
};

export default DgSpinnerFull;
